import { EnhancementData } from "../interfaces/IEnhancementForCghs";
import { PATIENT_APIS, PROCEDURES } from "../utils/constants";
import Axios from "../utils/axiosInterceptor";

export const fetchEnhancementDataService = async (
  caseId: string | number,
  visitId: string | number
) => {
  const response = await Axios.get<EnhancementData[]>(
    `${PATIENT_APIS.GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitId}/getAll`
  );
  return response.data;
};

export const PostEnhancementData = async (
  caseId: string | number,
  visitId: string | number,
  portalMetaDataId:  string | number,
  payload: any, 
) => {
  const response = await Axios.post<any>(
    `${PATIENT_APIS.GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitId}/portalMetaData/${portalMetaDataId}/caseEnhancement`, payload
  );
  return response.data;
}

export const fetchProcedures = async (data: any): Promise<any> => {
  try {
    const response = await Axios.post(`${PROCEDURES.PROCEDURES_LIST}`, data);
    return response.data;
  } catch (error) {
    console.error("Error Type data:", error);
    throw error;
  }
};
export const fetchSpecialities = async (): Promise<any> => {
  try {
    const response = await Axios.get(`${PROCEDURES.SPECIALITY_LIST}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching credit Number", error);
    throw new Error("Cannot fetch credit Number");
  }
};
